import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../App';
import { useAuth } from '../AuthContext';
import { t } from '../i18n';
import { motion } from 'framer-motion';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function RegisterPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get('ref') || '';
  const { language } = useLanguage();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(name, email, password, schoolName, refCode);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = `${BACKEND_URL}/api/auth/google/start`;
  };

  return (
    <div className="auth-page">
      <motion.div className="auth-card" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <div className="auth-logo">
          <img src="/pantass-logo.jpg" alt="PANTASS" style={{ width: 40, height: 40, borderRadius: 10 }} />
          <span className="auth-logo-text">PANTASS</span>
        </div>
        <h1 className="auth-title">{t('registerTitle', language)}</h1>
        <p className="auth-subtitle">{t('registerSubtitle', language)}</p>

        {/* Google Sign Up Button */}
        <button className="google-auth-btn" onClick={handleGoogleLogin} data-testid="google-register-btn">
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          {t('signUpWithGoogle', language)}
        </button>

        <div className="auth-divider">
          <span>{t('orRegisterWith', language)}</span>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label>{t('nameLabel', language)}</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)}
              placeholder={t('namePlaceholder', language)} required data-testid="register-name" />
          </div>
          <div className="auth-field">
            <label>{t('email', language)}</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="cikgu@sekolah.my" required data-testid="register-email" />
          </div>
          <div className="auth-field">
            <label>{t('passwordLabel', language)}</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder={t('passwordPlaceholder', language)} required minLength={6} data-testid="register-password" />
          </div>
          <div className="auth-field">
            <label>{t('schoolName', language)} ({t('optional', language)})</label>
            <input type="text" value={schoolName} onChange={e => setSchoolName(e.target.value)}
              placeholder={t('enterSchoolName', language)} data-testid="register-school" />
          </div>
          <button type="submit" className="auth-submit" disabled={loading} data-testid="register-submit">
            {loading ? '...' : t('registerBtn', language)}
          </button>
        </form>

        <p className="auth-switch">
          {t('haveAccount', language)} <Link to="/login" className="auth-link">{t('loginBtn', language)}</Link>
        </p>
        <div className="auth-legal-links">
          <Link to="/privacy">{language === 'bm' ? 'Dasar Privasi' : 'Privacy Policy'}</Link>
          <span>&middot;</span>
          <Link to="/terms">{language === 'bm' ? 'Terma Perkhidmatan' : 'Terms of Service'}</Link>
        </div>
      </motion.div>
    </div>
  );
}
